import React from 'react'
import { findDOMNode } from 'react-dom'
import LayoutAdmin from './layoutadmin'
import { inject, observer } from 'mobx-react'
import { withLayoutAdmin } from '../../utils/hoc'
import Grid from 'material-ui/Grid'
import Card, { CardContent } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import Input, { InputAdornment } from 'material-ui/Input'
import Typography from 'material-ui/Typography'
import { CirclePicker } from 'react-color'
import Popover from 'material-ui/Popover'
import Button from 'material-ui/Button'
import Switch from 'material-ui/Switch'
import T from 'i18n-react'
import { yellow,red } from 'material-ui/colors'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Tooltip from 'material-ui/Tooltip'
import { Link } from 'react-router-dom'
import route from '../../stores/fetchconfig.json'


@inject('admin','adminui','messenger') @observer
class Settings extends React.Component {
 render () {
  const settings = this.props.admin.settings, xs = 12, sm = 6, md = 4, lg = 4,
        ui = this.props.adminui, admin = this.props.admin, collectionType = admin.beispieltypen.getCollectionType()

  return (
   <Grid container direction="column" justify="center" align="center" spacing={Number(0)}>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card style={{backgroundColor:settings.primaryColor}}>
      <CardContent>
       <Typography type="headline" component="h2"> {T.translate("admin.settings.primaryColor")} </Typography>

        <Button
         color="inherit"
         ref={btn => { this.primaryColorButton = btn }}
         onClick={ui.handleOpenPrimaryColorPopover}
        >
         {T.translate("admin.settings.selectColor")}
        </Button>
        <Popover
         open={ui.openPrimaryColorPopover}
         anchorEl={findDOMNode(this.primaryColorButton)}
         onClose={ui.handleClosePrimaryColorPopover}
         anchorOrigin={{
          vertical: "center",
          horizontal: "center"
         }}
         PaperProps={{
           style:{padding:5}
         }}
         transformOrigin={{
          vertical: "center",
          horizontal: "center"
         }}
        >
         <CirclePicker
          color={settings.primaryColor}
          onChangeComplete={this.setPrimaryColor}
         />
        </Popover>

      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card style={{backgroundColor:settings.accentColor}}>
      <CardContent>
       <Typography type="headline" component="h2"> {T.translate("admin.settings.accentColor")} </Typography>

        <Button
         color="inherit"
         ref={btn => { this.accentColorButton = btn }}
         onClick={ui.handleOpenAccentColorPopover}
        >
         {T.translate("admin.settings.selectColor")}
        </Button>
        <Popover
         open={ui.openAccentColorPopover}
         anchorEl={findDOMNode(this.accentColorButton)}
         onClose={ui.handleCloseAccentColorPopover}
         PaperProps={{
           style:{padding:5}
         }}
         anchorOrigin={{
          vertical: "center",
          horizontal: "center"
         }}
         transformOrigin={{
          vertical: "center",
          horizontal: "center"
         }}
        >
         <CirclePicker
          color={settings.accentColor}
          onChangeComplete={this.setAccentColor}
         />
        </Popover>

      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card>
      <CardContent>

       <Typography type="caption" component="p"> {T.translate("admin.settings.editCatalogItemsDescription")} </Typography>
       <Link to={route.endpoint + "/"} className="unstyle-a">
        <Button color="secondary"> {T.translate("admin.settings.editCatalogItemsTitle")} </Button>
       </Link>
      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card>
      <CardContent>
       <Typography type="headline" component="h2"> {T.translate("admin.settings.menuLink")} 1</Typography>
       <Typography type="caption" component="p"> {T.translate("admin.settings.menuLinkDescription")} </Typography>
       <TextField
        id="menu-link-one-url"
        label={T.translate('meta.link')}
        value={settings.menuLinkOne.url}
        onChange={e => settings.setMenuLinkOne(e.target.value)}
        onBlur={this.saveMenuLinks}
        fullWidth
       />
       <TextField
        id="menu-link-one-description"
        label={T.translate('admin.settings.menuLinkHowTo')}
        value={settings.menuLinkOne.description}
        onChange={e => settings.setMenuLinkOneDescription(e.target.value)}
        onBlur={this.saveMenuLinks}
        fullWidth
       />
      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card>
      <CardContent>
       <Typography type="headline" component="h2"> {T.translate("admin.settings.menuLink")} 2</Typography>
       <Typography type="caption" component="p"> {T.translate("admin.settings.menuLinkDescription")} </Typography>
       <TextField
        id="menu-link-two-url"
        label={T.translate('meta.link')}
        value={settings.menuLinkTwo.url}
        onChange={e => settings.setMenuLinkTwo(e.target.value)}
        onBlur={this.saveMenuLinks}
        fullWidth
       />
       <TextField
        id="menu-link-two-description"
        label={T.translate('admin.settings.menuLinkHowTo')}
        value={settings.menuLinkTwo.description}
        onChange={e => settings.setMenuLinkTwoDescription(e.target.value)}
        onBlur={this.saveMenuLinks}
        fullWidth
       />
      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card>
      <CardContent className="rel">
       <Typography type="headline" component="h2"> {T.translate("admin.settings.exampleTypes")}</Typography>
       <Typography type="caption" component="p"> {T.translate("admin.settings.exampleTypesDescription")} </Typography>

        <div style={{marginTop:20,marginBottom:20}}>
         {admin.beispieltypen.getExampletypes().map((beispieltyp,index) => {

          return <Input
                  id={"beispieltyp-"+beispieltyp.id}
                  key={"beispieltyp-key-"+beispieltyp.id}
                  type='text'
                  fullWidth
                  value={beispieltyp.name}
                  onChange={this.handleChangeBeispieltyp.bind(this,beispieltyp.id)}
                  onBlur={this.saveType}
                  endAdornment={
                   <InputAdornment position="end">
                    <Tooltip
                     placement="left"
                     title={beispieltyp.deleted?T.translate("admin.settings.addToSearchFilters"):T.translate("admin.settings.removeFromSearchFilters")}
                    >
                     <IconButton onClick={this.handleDeleteBeispieltyp.bind(this,beispieltyp.id)}>
                      <Icon style={{color:beispieltyp.deleted?red[500]:''}}>{!beispieltyp.deleted ? "visibility" : "visibility_off"}</Icon>
                     </IconButton>
                    </Tooltip>
                   </InputAdornment>
                  }
                 />
          })
         }
        </div>

        <div className="callout" style={{borderLeftColor:yellow[500],marginTop:0}}>
         <Typography type="caption">
         <Icon style={{color:yellow[500]}}>warning</Icon>
         {T.translate("admin.settings.exampleTypesHint")}
        </Typography>
       </div>

       <Tooltip title={T.translate("admin.settings.addBeispieltyp")} placement="top">
        <Button
         fab
         color="secondary"
         dense={true}
         aria-label="add-beispieltyp"
         style={{position:'absolute',right:15,bottom:10}}
         onClick={admin.beispieltypen.addEmptyType}
        >
         <Icon>add</Icon>
        </Button>
       </Tooltip>

      </CardContent>
     </Card>
    </Grid>

    <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
     <Card>
      <CardContent className="rel">
       <Typography type="headline" component="h2"> {T.translate("admin.settings.collectionType")}</Typography>
       <Typography type="caption" component="p"> {T.translate("admin.settings.collectionTypeDescription")} </Typography>

        <div style={{marginTop:20,marginBottom:20}}>
         <Input
          id={"collectiontype"}
          key={"collectiontype-key"}
          type='text'
          placeholder={T.translate('admin.settings.collectionname')}
          fullWidth
          value={collectionType.name}
          onChange={this.handleChangeBeispieltyp.bind(this,collectionType.id)}
          onBlur={this.saveType}
         />
         {settings.collectionimage && settings.collectionimage !== "" &&
          <img style={{width:'100%'}} src={settings.collectionimage} alt="" />
         }

         <TextField
          id="settings-collectionimage"
          value={settings.collectionimage}
          onChange={this.setCollectionimage}
          onBlur={this.saveCollectionimage}
          placeholder={T.translate('admin.settings.collectionimage')}
          fullWidth
         />
        </div>

      </CardContent>
     </Card>
    </Grid>

   </Grid>
  )
 }

 componentDidMount () {
   this.setState({primaryColorAnchorEl:findDOMNode(this.primaryColorButton)})
   this.setState({accentColorAnchorEl:findDOMNode(this.accentColorButton)})
 }

 componentWillMount () {
   this.props.admin.getSettings()
   this.props.admin.getBeispieltypen()
 }

 setCollectionimage = (e) => {
   this.props.admin.settings.setCollectionimage(e.target.value)
 }
 saveCollectionimage = () => {
   this.props.admin.settings.saveCollectionimage((res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

 setPrimaryColor = (color,event) => {
   this.props.admin.settings.setPrimaryColor(color.hex, (res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

 setAccentColor = (color,event) => {
   this.props.admin.settings.setAccentColor(color.hex, (res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

 handleChangeBeispieltyp = (id,e) => {
   this.props.admin.beispieltypen.changeName(id,e.target.value)
 }

 handleDeleteBeispieltyp = (id) => {
   this.props.admin.beispieltypen.changeDeletedState(id, (res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

 saveType = (e) => {
   this.props.admin.beispieltypen.saveTypes((res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

 saveMenuLinks = (e) => {
   this.props.admin.settings.saveMenuLinks((res) => {
     if (res.success) {
      this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
 }

}


export default withLayoutAdmin(Settings)



// WEBPACK FOOTER //
// ./src/components/admin/settings.js